const SERVER_URL ="https://app.tapeasy.me";
// const SERVER_URL ="http://localhost:3001"; // Replace with your actual server URL

export default SERVER_URL;
